export enum OPERATOR_SERVICE_CENTER_PAGES {
  DOCUMENT_PAGE,
  BORROWER_PAGE,
  BORROWER_RESTRICTION_PAGE,
  BORROWER_REEVALUATION_PAGE,
  APPLICATION_REEVALUATION_RESULT_PAGE,
}
